<template>
    <div class="mcp-manager">
      <h1 class="title">Configuration MCP (Model Context Protocol)</h1>
  
      <!-- Ajouter un Contexte -->
      <section class="section">
        <h2>Ajouter un Contexte</h2>
        <div class="form">
          <input v-model="newContext.name" placeholder="Nom du contexte (ex: Vente)" />
          <textarea v-model="newContext.description" placeholder="Description du contexte" />
          <button @click="addContext">Ajouter</button>
        </div>
      </section>
  
      <!-- Liste des Contextes -->
      <section class="section" v-if="contexts.length">
        <h2>Contextes existants</h2>
  
        <div v-for="(context, index) in contexts" :key="index" class="context-block">
          <div class="context-header">
            <h3>{{ context.name }}</h3>
            <button @click="deleteContext(index)" class="delete-btn">Supprimer</button>
          </div>
          <p>{{ context.description }}</p>
  
          <!-- Ajouter une Règle au Contexte -->
          <div class="form">
            <input v-model="newRule.name" placeholder="Nom de la règle (ex: Demander Nom)" />
            <input v-model="newRule.condition" placeholder="Condition (ex: Utilisateur dit son nom)" />
            <input v-model="newRule.action" placeholder="Action (ex: Stocker nom dans base)" />
            <button @click="addRule(index)">Ajouter la règle</button>
          </div>
  
          <!-- Liste des règles -->
          <ul class="rules-list">
            <li v-for="(rule, ruleIndex) in context.rules" :key="ruleIndex">
              <strong>{{ rule.name }}:</strong> {{ rule.condition }} ➔ {{ rule.action }}
              <button @click="deleteRule(index, ruleIndex)" class="delete-btn-small">✕</button>
            </li>
          </ul>
        </div>
      </section>
  
      <!-- Sauvegarder le MCP (plus tard connecté au backend) -->
      <div class="submit-section" v-if="contexts.length">
        <button class="submit-btn" @click="saveMCP">Sauvegarder le MCP</button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue'
  import Cookies from 'js-cookie'

  import { reactive } from 'vue';
  import { useRouter } from 'vue-router'
  const router = useRouter()
  
  async function mounted() {
    const token = Cookies.get('token')
    if (!token) return router.push('/sign-in')
  }
  onMounted(mounted)

  const newContext = reactive({
    name: '',
    description: '',
    rules: []
  });
  
  const newRule = reactive({
    name: '',
    condition: '',
    action: ''
  });
  
  const contexts = reactive([]);
  
  // Ajouter un contexte
  function addContext() {
    if (newContext.name && newContext.description) {
      contexts.push({ ...newContext, rules: [] });
      newContext.name = '';
      newContext.description = '';
    }
  }
  
  // Ajouter une règle dans un contexte
  function addRule(contextIndex) {
    if (newRule.name && newRule.condition && newRule.action) {
      contexts[contextIndex].rules.push({ ...newRule });
      newRule.name = '';
      newRule.condition = '';
      newRule.action = '';
    }
  }
  
  // Supprimer un contexte
  function deleteContext(index) {
    contexts.splice(index, 1);
  }
  
  // Supprimer une règle
  function deleteRule(contextIndex, ruleIndex) {
    contexts[contextIndex].rules.splice(ruleIndex, 1);
  }
  
  // Sauvegarder MCP (plus tard à brancher sur backend)
  function saveMCP() {
    console.log('MCP sauvegardé:', contexts);
    alert('MCP sauvegardé ! (simulé)');
  }
  </script>
  
  <style scoped>
  .mcp-manager {
    padding: 20px;
    background: #f9fafb;
  }
  
  .title {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .section {
    margin-bottom: 30px;
  }
  
  .form input, .form textarea {
    display: block;
    width: 100%;
    margin-bottom: 10px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
  }
  
  .form button {
    background-color: #6366f1;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }
  
  .context-block {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .context-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .delete-btn, .delete-btn-small {
    background: #ef4444;
    border: none;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .delete-btn-small {
    margin-left: 10px;
  }
  
  .rules-list {
    margin-top: 10px;
  }
  
  .submit-section {
    text-align: center;
  }
  
  .submit-btn {
    background-color: #10b981;
    color: white;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 8px;
  }
  </style>
  